import MainCourse from "./index.vue";
import CourseList from "./List.vue";
import CourseDetail from "./Detail.vue";
import Assist from "./Assist.vue";
import CoursePreview from "./CoursePreview.vue";

export default {
  name: "MainCourse",
  path: "course",
  redirect: "course/list",
  component: MainCourse,
  meta: {
    label: "课时管理",
  },
  children: [
    {
      name: "CourseList",
      path: "list",
      component: CourseList,
      meta: {
        label: "课时列表",
      },
    },
    {
      name: "CourseDetail",
      path: ":id/:structure_id",
      component: CourseDetail,
      meta: {
        label: "课时详情",
      },
      children: [
        // {
        //   name: 'CoursePreview',
        //   path: 'course_preview/:courseID/:theme_id',
        //   component: CoursePreview,
        //   meta: {
        //     label: 'cocos预览',
        //   },
        // },
      ],
    },
    {
      name: "Assist",
      path: "assist",
      component: Assist,
      meta: {
        label: "辅师备课内容",
      },
    },
    {
      name: "CoursePreview",
      path: "/course_preview/:courseID/:theme_id",
      component: CoursePreview,
      meta: {
        label: "cocos预览课件",
      },
    },

  ],
};

